import { type SalesLead } from '@/models/salesLead'
import { ScopedAgentChat } from '../AgentChat/ScopedAgentChat'

interface AgentChatTabProps {
  lead: SalesLead
}

export function AgentChatTab({ lead }: AgentChatTabProps) {
  return <ScopedAgentChat scope={{ salesLead: lead.id }} />
}
